import angular from 'angular';

function compareTo() {
  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo',
    },
    link(scope, element, attributes, ngModel) {
      ngModel.$validators.compareTo = modelValue => modelValue === scope.otherModelValue;

      const stopWatch = scope.$watch('otherModelValue', () => {
        ngModel.$validate();
      });
      scope.$on('$destroy', () => {
        stopWatch();
      });
    },
  };
}
export default compareTo;



// WEBPACK FOOTER //
// ./client/app/common/compareTo/compareTo.directive.js